export default "__VITE_ASSET__B9w_h5a$__";